export const BROKERAGE_SCHWAB = 'schwab';
export const BROKERAGE_TRADOVATE = 'tradovate';

export const TENANT_INVESTCEO = 'investceo';
export const TENANT_SMITHFIELD = 'smithfield';

// Options tiers, per-algo contract caps and account limits live in
// optionsLimits.js (shared verbatim with the serverless API and engine).

export const TENANT_BROKERAGE_MAP = {
    [TENANT_INVESTCEO]: [BROKERAGE_TRADOVATE],
    [TENANT_SMITHFIELD]: [BROKERAGE_SCHWAB],
};

// Smithfield options algos. `entitlement` is the lowercase slug on the user
// record; `algoName` is the value stored in the trade log and sent to the API.
// Keep in sync with OPTIONS_ALGOS in the serverless API's utils/optionsMetrics.js.
export const OPTIONS_ALGOS = [
    { algoName: 'MarketPower', entitlement: 'marketpower', label: 'Market Power' },
    { algoName: 'DoubleDip', entitlement: 'doubledip', label: 'Double Dip' },
    { algoName: 'Phoenix', entitlement: 'phoenix', label: 'Phoenix' },
    { algoName: 'GoodMorning', entitlement: 'goodmorning', label: 'Good Morning' },
    { algoName: 'LastCall', entitlement: 'lastcall', label: 'Last Call' },
];

// Template-anchored income progression. Each tier maps a monthly income target
// to a minimum account size and a per-algo configuration.
//
// This is a hand-maintained table, NOT derived from live results — update it
// when the underlying templates or performance change. `contracts` is the
// number of contracts per algo; `ticker` is which instrument that algo trades.
export const INCOME_TIERS = [
    { target: 500,   minCapital: 14000,
      config: { DoubleDip: { contracts: 3, ticker: 'SPX' }, MarketPower: { contracts: 1, ticker: 'SPX' }, GoodMorning: { contracts: 1, ticker: 'XSP' } } },
    { target: 1000,  minCapital: 23000,
      config: { DoubleDip: { contracts: 3, ticker: 'SPX' }, MarketPower: { contracts: 1, ticker: 'SPX' }, GoodMorning: { contracts: 2, ticker: 'XSP' } } },
    { target: 3000,  minCapital: 45500,
      config: { DoubleDip: { contracts: 3, ticker: 'SPX' }, MarketPower: { contracts: 1, ticker: 'SPX' }, GoodMorning: { contracts: 2, ticker: 'XSP' }, LastCall: { contracts: 1, ticker: 'SPX' } } },
    { target: 6000,  minCapital: 101000, id: '6000-standard', label: 'Standard',
      config: { DoubleDip: { contracts: 3, ticker: 'SPX' }, MarketPower: { contracts: 1, ticker: 'SPX' }, GoodMorning: { contracts: 1, ticker: 'SPX' }, LastCall: { contracts: 2, ticker: 'SPX' } } },
    // Conservative variant of the $6,000 tier: Last Call swapped for a single
    // Phoenix contract. `id` keeps it distinct from the tier above, which shares
    // the same monthly target.
    { target: 6000,  minCapital: 101000, id: '6000-conservative', label: 'Conservative',
      config: { DoubleDip: { contracts: 3, ticker: 'SPX' }, MarketPower: { contracts: 1, ticker: 'SPX' }, Phoenix: { contracts: 1, ticker: 'SPX' }, GoodMorning: { contracts: 1, ticker: 'SPX' } } },
];